import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import { Row } from 'blocks/CommonLayout';
import { PageTitle } from 'blocks/Text';
import CreditCard from 'components/CreditCard';
import Form, { DatePicker, TextField } from 'components/Form';
import Loading from 'components/Loading';
import { getDate } from 'helper/date';
import Paths from 'helper/paths';
import WithSidebar from 'layouts/WithSidebar';
import TierInfoCards from 'pages/Dashboard/TierInfoCards';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import * as S from './cardFFp.styles';
import ModalConfirmation from './modals/ConfirmationDetail';
import ProductPurchaseModal from './modals/ProductPurchaseModal';
const CreateCard = () => {
  const { setValue, getValues, handleSubmit, register } = useForm<any>();
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [showModalProductPurchas, setShowModalProductPurchas] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState();
  const [cardDetail, setCardDetail] = useState<any>({});
  const [productBooking, setProductBooking] = useState<any>({});
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const createInquiry = async (data) => {
    const newData = {
      deliveryDate: getDate(data.deliveryDate, 'YYYY-MM-DD'),
      productId: Number(id),

      merchantId: state,
    };
    setLoading(true);
    const res = await ajax({
      url: urls.createInquiry,
      method: 'POST',
      data: newData,
    }).finally(() => setLoading(false));
    if (!res) return;
    setCardDetail(res);
  };
  const handleSendOtp = async () => {
    const data = {
      productId: Number(id),
      merchantId: state,
      description: getValues('description'),
      deliveryDate: getValues('deliveryDate'),
    };
    setLoading(true);
    const res = await ajax({
      url: urls.inquiryOtp,
      method: 'POST',
      data: data,
    }).finally(() => setLoading(false));

    if (!res) return;
    setProductBooking(res);
    setShowModalConfirmation(true);
  };
  return (
    <WithSidebar>
      <S.Wrapper>
        <Row style={{ marginBottom: '1rem' }} justify="space-between">
          <div></div>
          <Button onClick={() => navigate(Paths.Services.products().route)}>
            {t('pages.services.Products.sections.Card.btnBack')}
          </Button>
        </Row>

        <Card>
          <BoxWrapper>
            <Form>
              <S.RowHead as={Row} justify="space-between" align="center">
                <S.containerTitleAndInput>
                  <S.containerTitle>
                    <S.PageTitle as={PageTitle}>{t('pages.services.Products.sections.Card.title')}</S.PageTitle>
                  </S.containerTitle>
                </S.containerTitleAndInput>
              </S.RowHead>
              <S.RowCreateCart as={Row} justify="space-between">
                <S.Delivery>
                  <DatePicker
                    label={t('pages.services.Products.sections.Card.fields.DeliveryDate.label')}
                    onChange={(date: any) => setValue('deliveryDate', date)}
                    defaultValue={getValues('deliveryDate')}
                    disabled={!(Object.keys(cardDetail).length === 0)}
                  />
                </S.Delivery>
              </S.RowCreateCart>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button fullWidth width={200} onClick={handleSubmit(createInquiry)}>
                  {t('pages.services.Products.sections.Card.sendBtn')}
                </Button>
              </div>
            </Form>
          </BoxWrapper>

          {loading ? (
            <Loading />
          ) : (
            <BoxWrapper>
              {Object.keys(cardDetail).length === 0 ? (
                ''
              ) : (
                <S.CreditCardWrraper>
                  <CreditCard
                    type={cardDetail.user.Tier.name}
                    name={cardDetail?.user.enFname + '' + cardDetail?.user.enLname}
                    idNumber={cardDetail.user.idNumber}
                    date={new Date()}
                    color={cardDetail.user.Tier.color}
                  />
                  <div style={{ margin: '10px 0px' }}>
                    <TierInfoCards user={cardDetail.user.rewardMilage} price={cardDetail.price.rewardMilage} />
                  </div>
                  <div style={{ marginBottom: '10px', width: '25%' }}>
                    <TextField
                      muliLine
                      control={register('description')}
                      placeholder={t('pages.services.Products.sections.Card.descriptionpleaseholder')}
                      label={t('pages.services.Products.sections.Card.description')}
                    />
                  </div>
                  <div style={{ margin: '10px 0px' }}>
                    <Button
                      fullWidth
                      width={200}
                      onClick={() => {
                        if (cardDetail.user.rewardMilage >= cardDetail.price.rewardMilage) handleSendOtp();
                      }}
                    >
                      {t('pages.services.Products.sections.Card.confirmationBtn')}
                    </Button>
                  </div>
                </S.CreditCardWrraper>
              )}
            </BoxWrapper>
          )}
        </Card>
      </S.Wrapper>
      <ModalConfirmation
        productBookingId={productBooking}
        open={showModalConfirmation}
        onClose={() => setShowModalConfirmation(false)}
        setStatusPurchase={setStatusPurchase}
        setShowModalProductPurchas={setShowModalProductPurchas}
      />
      <ProductPurchaseModal
        productBookingId={productBooking}
        open={showModalProductPurchas}
        onClose={() => setShowModalProductPurchas(false)}
        statusPurchase={statusPurchase}
        setCardDetail={setCardDetail}
      />
    </WithSidebar>
  );
};

export default CreateCard;
